import { Theme } from '@mui/material/styles'

import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({

    root: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
      gridGap: theme.spacing(2),
    },

    titleHr: {
      marginBottom: theme.spacing(4),
    },

    userEmail: {
      backgroundColor: '#f5f5f5',
      border: '1px solid #ccc',
      borderRadius: '4px',
      padding: '2px 6px',
      color: theme.palette.grey[900],
    },

    logoutButton: {
      marginTop: theme.spacing(3),
    },

  })
)

export default useStyles
